ixModuleRouting("impactx.subsequentpurchaseorderdata", {
    "/commpglist": {
        template: "<ixa-commpg-list></ixa-commpg-list>",
        process: "AdministrateSubsequentPurchaseOrderdata",
        workspace: "admin",
    },
    "/commpg/:id": {
        template: "<ixa-commpg></ixa-commpg>",
        process: "AdministrateSubsequentPurchaseOrderdata",
        workspace: "admin",
    },
    "/comspoaddtextlist": {
        template: "<ixa-comspoaddtext-list></ixa-comspoaddtext-list>",
        process: "AdministrateSubsequentPurchaseOrderdata",
        workspace: "admin",
    },
    "/comspoaddtext/:id": {
        template: "<ixa-comspoaddtext></ixa-comspoaddtext>",
        process: "AdministrateSubsequentPurchaseOrderdata",
        workspace: "admin",
    },
    "/comtctlist": {
        template: "<ixa-comtct-list></ixa-comtct-list>",
        process: "AdministrateSubsequentPurchaseOrderdata",
        workspace: "admin",
    },
    "/comtct/:id": {
        template: "<ixa-comtct></ixa-comtct>",
        process: "AdministrateSubsequentPurchaseOrderdata",
        workspace: "admin",
    },
    "/comtthlist": {
        template: "<ixa-comtth-list></ixa-comtth-list>",
        process: "AdministrateSubsequentPurchaseOrderdata",
        workspace: "admin",
    },
    "/comtth/:id": {
        template: "<ixa-comtth></ixa-comtth>",
        process: "AdministrateSubsequentPurchaseOrderdata",
        workspace: "admin",
    },
    "/comtttlist": {
        template: "<ixa-comttt-list></ixa-comttt-list>",
        process: "AdministrateSubsequentPurchaseOrderdata",
        workspace: "admin",
    },
    "/comttt/:id": {
        template: "<ixa-comttt></ixa-comttt>",
        process: "AdministrateSubsequentPurchaseOrderdata",
        workspace: "admin",
    },
    "/comspglist": {
        template: "<ixa-comspg-list></ixa-comspg-list>",
        process: "AdministrateSubsequentPurchaseOrderdata",
        workspace: "admin",
    },
    "/comspg/:id": {
        template: "<ixa-comspg></ixa-comspg>",
        process: "AdministrateSubsequentPurchaseOrderdata",
        workspace: "admin",
    },
    "/spoaddtextlist": {
        template: "<ixa-spoaddtext-list></ixa-spoaddtext-list>",
        process: "AdministrateSubsequentPurchaseOrderdata",
        workspace: "admin",
    },
    "/spoaddtext/:id": {
        template: "<ixa-spoaddtext></ixa-spoaddtext>",
        process: "AdministrateSubsequentPurchaseOrderdata",
        workspace: "admin",
    }
});